const BASE_CONST = 'REPORTS_INVOICES_V2';

// Invoices action constants
export const REPORTS_INVOICES_PAGE_REQUEST = `${BASE_CONST}_PAGE_REQUEST`;
export const REPORTS_INVOICES_LIST_INVOICE_REQUEST = `${BASE_CONST}_LIST_INVOICE_REQUEST`;
export const REPORTS_INVOICES_SET_LIST_INVOICE = `${BASE_CONST}_SET_LIST_INVOICE`;
export const REPORTS_INVOICES_SET_OUTLETS = `${BASE_CONST}_SET_OUTLETS`;
export const REPORTS_INVOICES_SET_NEXT_CURSOR = `${BASE_CONST}_SET_NEXT_CURSOR`;
export const REPORTS_INVOICES_SET_HAS_MORE = `${BASE_CONST}_SET_HAS_MORE`;
export const REPORTS_INVOICES_ON_REACH_BOTTOM = `${BASE_CONST}_ON_REACH_BOTTOM`;
export const REPORTS_INVOICES_ON_SEARCH = `${BASE_CONST}_ON_SEARCH`;

// Filter invoices constants
export const REPORTS_INVOICES_CHANGE_DATE = `${BASE_CONST}_CHANGE_DATE`;
export const REPORTS_INVOICES_CHANGE_OUTLET = `${BASE_CONST}_CHANGE_OUTLET`;
export const REPORTS_INVOICES_CHANGE_STATUS = `${BASE_CONST}_CHANGE_STATUS`;
